import clsx from "clsx"
import { SpinnerCircular } from "spinners-react"
import { FC, PropsWithChildren, Suspense } from "react"
import styles from "./index.module.scss"

interface IPageSuspense {
  style?:
    | "quests"
    | "under-maintenance"
    | "green"
    | "clans"
    | "inventory"
    | "purple"
    | "dark-blue"
  Component?: FC
}

export const PageSuspense: FC<PropsWithChildren<IPageSuspense>> = ({
  children,

  style = "brown",
  Component
}) => {
  return (
    <Suspense
      fallback={
        <div className={clsx(styles.PageSuspense, styles[style])}>
          <SpinnerCircular
            size={48}
            color="#ffd180"
            className="loading-spinner"
          />
        </div>
      }
    >
      {Component && <Component />}
      {children}
    </Suspense>
  )
}
